import { z } from 'zod';
/**
 * The log in form's rules and its messages, written once here so the dashboard
 * shows the same text whether it checks before sending or after
 * (`patterns/error-handling.md`, 3). The copy is `ux.md`, Content.
 *
 * Spaces around the email address are ignored rather than counted as a format
 * error (`ux.md`, States). A password is never trimmed or case-folded.
 */
export const LOGIN_FORM_MESSAGES = {
    emailRequired: 'Enter your email address.',
    emailFormat: 'Enter an email address in the format name@example.com.',
    passwordRequired: 'Enter your password.',
};
/**
 * Piped rather than chained: each step only runs once the one before it has
 * passed, so an empty field reports "Enter your email address." and nothing
 * else.
 */
const emailSchema = z
    .string()
    .transform((value) => value.trim())
    .pipe(z.string().min(1, { error: LOGIN_FORM_MESSAGES.emailRequired }))
    .pipe(z.email({ error: LOGIN_FORM_MESSAGES.emailFormat }));
export const loginFormSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, { error: LOGIN_FORM_MESSAGES.passwordRequired }),
});
//# sourceMappingURL=login-form.js.map